// Floor plan positioning constants

/**
 * Configuration for floor plan grid calculations
 */
export const FLOOR_PLAN_CONFIG = {
  /** Size of each grid cell in pixels */
  PIXELS_PER_CASE: 15,
  /** Pixels per meter for scaling */
  PIXELS_PER_METER: 50,
  /** Reference width used in J1 for scaling calculations */
  REFERENCE_WIDTH: 900,
} as const;

/**
 * Fixed size for arbitrary pictos (booking pins, user avatars)
 * Used when we don't want to scale the picto with the resource type
 */
export const ARBITRARY_PICTO_SIZE = 75;
